var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgScanner = function SvgScanner(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M10.522 5.014a6.36 6.36 0 0 0-7.156 1.508.5.5 0 1 1-.732-.682 7.36 7.36 0 0 1 10.73-.037.5.5 0 1 1-.727.687 6.4 6.4 0 0 0-2.116-1.476M9.62 7.115a4.07 4.07 0 0 0-4.582.965.5.5 0 1 1-.731-.682 5.07 5.07 0 0 1 7.395-.025.5.5 0 1 1-.727.687 4.1 4.1 0 0 0-1.355-.945m-.675 2.147a2.36 2.36 0 0 0-2.653.559.5.5 0 1 1-.732-.682 3.36 3.36 0 0 1 4.896-.017.5.5 0 1 1-.726.687 2.4 2.4 0 0 0-.785-.547m-2 2.167a1.072 1.072 0 1 1 2.143 0 1.072 1.072 0 0 1-2.143 0m1.071-.072a.072.072 0 1 0 0 .143.072.072 0 0 0 0-.143",
    clipRule: "evenodd"
  })));
};
export { SvgScanner as ReactComponent };
export default __webpack_public_path__ + "38c7a93c24f783190d1799f90dc64760.svg";